import {
  IBrandQueryRequest,
  IPracticeQueryRequest,
  isBrandQueryRequest,
  isPracticeQueryRequest,
  QueryScopeConfigId,
} from '@principle-theorem/principle-core/interfaces';
import {
  BuiltQueryScope,
  IQueryScopeConfig,
} from '@principle-theorem/reporting/interfaces';
import { BigQuerySQL } from '../big-query-sql';
import { FACT_TABLE_PREFIX, toFactPropertyName } from '../models/base-measures';

export class BrandQueryScopeConfig
  implements IQueryScopeConfig<IBrandQueryRequest>
{
  id = QueryScopeConfigId.Brand;
  isValid = isBrandQueryRequest;

  constructor(
    public required: boolean = false,
    private _targetRefPath: string = 'brand.ref.referenceValue'
  ) {}

  buildQuery(request: IBrandQueryRequest): BuiltQueryScope {
    const brandTarget = this._targetRefPath;
    const propertyPath = toFactPropertyName(brandTarget, FACT_TABLE_PREFIX);
    return {
      attributes: [brandTarget],
      filters: [BigQuerySQL.docRef(propertyPath, '=', request.brandRef)],
      joins: [],
    };
  }
}

export class PracticeQueryScopeConfig
  implements IQueryScopeConfig<IPracticeQueryRequest>
{
  id = QueryScopeConfigId.Practice;
  isValid = isPracticeQueryRequest;

  constructor(
    public required: boolean = false,
    private _targetRefPath: string = 'practice.ref.referenceValue'
  ) {}

  buildQuery(request: IPracticeQueryRequest): BuiltQueryScope {
    const practiceTarget = this._targetRefPath;
    const propertyPath = toFactPropertyName(practiceTarget, FACT_TABLE_PREFIX);
    const filter = BigQuerySQL.or(
      request.practiceRefs.map((practiceRef) =>
        BigQuerySQL.docRef(propertyPath, '=', practiceRef)
      )
    );
    return {
      attributes: [practiceTarget],
      filters: [filter],
      joins: [],
    };
  }
}
